import { FC, ReactNode } from "react";
import { CSSTransition } from "react-transition-group";
import { Constants } from "../../utils/Constants";
import clsx from "clsx";

type Props = {
    show: boolean;
    children: ReactNode;
    anchorTop?: boolean;
};

export const PageFadeAnimation: FC<Props> = (props: Props) => {
    const { animationDuration } = Constants;
    const { children, show, anchorTop } = props;

    return (
        <CSSTransition classNames="trans" in={show} timeout={animationDuration} unmountOnExit>
            <div className={clsx("trans", anchorTop && "trans--top")}>{children}</div>
        </CSSTransition>
    );
};

PageFadeAnimation.defaultProps = {
    anchorTop: false,
};
